import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../../componentes/loading/loading";

function ResumoTempoMedio({ dataApi, loading, filtrar }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);

  useEffect(() => {
    if (dataApi?.length > 0) {
      const {
        diasParaFinalizar,
        diasAteCotacao,
        diasAteAprovacao,
        diasAteCompra,
      } = dataApi[0];

      const etapas = [
        "Aprovação Solicitação até Cotação",
        "Cotação até Aprovação do Corporativo",
        "Aprovação Corp. até a Compra",
        "Total para Finalizar",
      ];

      const valores = [diasAteAprovacao, diasAteCotacao, diasAteCompra, diasParaFinalizar];
      const metas = [2, 2, 2, 2];

      setChartOptions({
        chart: {
          type: "line",
        },
        xaxis: {
          categories: etapas,
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        markers: {
          size: 5,
        },
        yaxis: {
          min: 0,
          max: 20,
          title: {
            text: "Dias",
          },
        },
        legend: {
          position: "top",
        },
        colors: ["#6366F1", "#10B981"],
      });

      setChartSeries([
        {
          name: "Tempo Médio (dias)",
          data: valores,
        },
        {
          name: "Meta (dias)",
          data: metas,
        },
      ]);
    }
  }, [filtrar, dataApi]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Métricas de Tempo Médio
      </h3>
      <label className="text-muted-foreground text-sm">
        Média de dias entre as etapas do processo de compras.
      </label>
      <div className="h-64">
        {!loading && chartSeries.length > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="line"
            height="100%"
          />
        ) : !loading ? (
          "Não existem dados para mostrar."
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}

export default ResumoTempoMedio;